"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** Hitagi capabilities plugin */
class HitagiPluginCapabilities {
    constructor() {
        this.voice_processing = true;
        this.my_show = false;
    }
    enable(cap) {
        this.change(cap, true);
    }
    disable(cap) {
        this.change(cap, false);
    }
    change(cap, value) {
        this[cap] = value;
    }
    mass_change(caps) {
        for (const i in caps) {
            this.change(i, caps[i]);
        }
    }
}
exports.default = HitagiPluginCapabilities;



//////////////////
// WEBPACK FOOTER
// ./node_modules/hitagi-js/build/hitagi_plugin_capabilities.js
// module id = ./node_modules/hitagi-js/build/hitagi_plugin_capabilities.js
// module chunks = main